import React from 'react';
import PropTypes from 'prop-types';
import {Doughnut} from 'react-chartjs-2';
import clsx from 'clsx';
import {makeStyles, useTheme} from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    Divider
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%'
    },
    cardContent: {
        height: '84%'
    },
    chartContainer: {
        position: 'relative',
        height: '100%'
    },
    stats: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center'
    }
}));

const RateByPlatform = props => {
    const {className, data, ...rest} = props;
    const classes = useStyles(props);
    const theme = useTheme();
    const {labels, point} = data;
    const colorSets = [
        theme.palette.primary.main,
        theme.palette.secondary.main,
        theme.palette.error.main,
        theme.palette.warning.main,
        theme.palette.info.main,
        theme.palette.success.main,
        theme.palette.primary.light,
        theme.palette.secondary.light,
        theme.palette.error.light,
        theme.palette.warning.light,
        theme.palette.info.light,
        theme.palette.success.light,
    ];
    const chartData = {
        datasets: [
            {
                data: point,
                backgroundColor: point.map((p, index) => colorSets[index]),
                borderWidth: 4,
                borderColor: theme.palette.white,
                hoverBorderColor: theme.palette.white
            }
        ],
        labels: labels
    };
    const chartOptions = {
        legend: {
            display: true,
            position: 'bottom'
        },
        responsive: true,
        maintainAspectRatio: false,
        animation: {
            animateScale: true,
            animateRotate: true
        },
        cutoutPercentage: 60,
        layout: {padding: 0},
        tooltips: {
            enabled: true,
            mode: 'nearest',
            intersect: true
        }
    };

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardHeader
                title="Rate By Platform"
            />
            <Divider/>
            <CardContent className={classes.cardContent}>
                <div className={classes.chartContainer}>
                    <Doughnut
                        data={chartData}
                        options={chartOptions}
                    />
                </div>
            </CardContent>
        </Card>
    );
};

RateByPlatform.propTypes = {
    className: PropTypes.string,
    data: PropTypes.object.isRequired
};

export default RateByPlatform;
